import { Col } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import VehicleInfo from '../../../ConfiguratorApplicationEntrypoint/ThankYou/VehicleInfo';
import { Title } from '../../../EventApplicationEntrypoint/ApplicantForm/shared';
import { type GiftVoucherState } from '../reducer';
import VehicleGiftDescription from './VehicleGiftDescription';

type VehicleDetailsProps = {
    state: GiftVoucherState;
};

const StyledTitle = styled(Title)`
    font-weight: 700;
`;
const GiftVoucherVehicleDetails = ({ state }: VehicleDetailsProps) => {
    const { giftVoucher } = state;

    const translatedString = useTranslatedString();

    const { t } = useTranslation(['paymentDetails', 'finderJourney']);

    const vehicleData = useMemo(() => {
        switch (giftVoucher.vehicle.__typename) {
            case 'LocalVariant': {
                const vehicleImage =
                    giftVoucher?.stock?.__typename === 'MobilityStockInventory' && giftVoucher.stock?.images?.length
                        ? giftVoucher.stock.images[0]
                        : giftVoucher.vehicle?.images?.[0];

                return {
                    make: translatedString(
                        giftVoucher.vehicle.model.parentModel
                            ? giftVoucher.vehicle.model.parentModel.make.name
                            : giftVoucher.vehicle.model.make.name
                    ),
                    variant: translatedString(giftVoucher.vehicle.name),
                    totalPrice: giftVoucher.value * giftVoucher.numberOfBookingReferenceDays,
                    filename: vehicleImage?.filename,
                    source: vehicleImage?.url,
                };
            }

            default:
                throw new Error('not implemented');
        }
    }, [
        giftVoucher.value,
        giftVoucher.vehicle,
        giftVoucher.stock,
        giftVoucher.numberOfBookingReferenceDays,
        translatedString,
    ]);

    if (!vehicleData) {
        return null;
    }

    return (
        <Col xs={24}>
            <StyledTitle> {t('paymentDetails:titles.selectedCar')}</StyledTitle>
            <VehicleInfo {...vehicleData} />
            <VehicleGiftDescription voucher={giftVoucher} />
        </Col>
    );
};

export default GiftVoucherVehicleDetails;
